import React, { useState } from "react";

export default (props) => {
    const [hover, setHovered] = useState(false);
    const estilosComType = {
        ...props.style,
        width: (props.style && props.style.width) || 40,
        height: (props.style && props.style.height) || 40,
        margin: 2,
        visibility: props.visible ? "visible" : "collapse",
        borderRadius: 4,
    };

    if (!props.solid && props.type !== 'light') {
        estilosComType.border = "none";
        estilosComType.boxShadow = `0px 0px 1px 2px ${hover && !props.disabled ? "transparent" : "#2222"}`;
    }

    return props.type ? (
        <button
            title={props.title}
            type={"button"}
            className={`btn btn-flat ${hover || props.solid || props.type === 'light' ? "" : "btn-light"} btn-${props.solid ? "" : "outline-"}${props.type}`}
            onClick={() => (props.disabled ? {} : props.event())}
            disabled={props.disabled}
            style={estilosComType}
        >
            {props.children || <i className={props.icon}></i>}
        </button>
    ) : (
        <button
            title={props.title}
            type={"button"}
            className={`btn btn-flat btn-${props.solid ? "" : "outline-"}`}
            onClick={() => (props.disabled ? {} : props.event())}
            disabled={props.disabled}
            style={{
                ...props.style,
                width: (props.style && props.style.width) || 40,
                height: (props.style && props.style.height) || 40,
                margin: 2,
                visibility: props.visible ? "visible" : "collapse",
                backgroundColor: hover && props.backgroundColorHover ? props.backgroundColorHover : props.style.backgroundColor,
                color: hover && props.colorHover ? props.colorHover : props.style.color,
                border: hover && props.borderHover ? props.borderHover : props.style.border,
            }}
            onMouseEnter={() => {
                setHovered(true);
            }}
            onMouseLeave={() => setHovered(false)}
        >
            {props.children || <i className={hover && props.iconHover ? props.iconHover : props.icon}></i>}
        </button>
    );
};

/*
primary
secondary
success
danger
warning
info
light
dark
link
*/
